/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dynamic_Ui_SendingInputs */

const en_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const ar_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ الإرسال...`)
};

const bn_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাঠানো হচ্ছে...`)
};

const de_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden...`)
};

const es_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando...`)
};

const fr_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi en cours...`)
};

const pt_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando...`)
};

const zh_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在发送...`)
};

const tr_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderiliyor...`)
};

const ru_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка...`)
};

const pl_dynamic_ui_sending = /** @type {(inputs: Dynamic_Ui_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłam...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Dynamic_Ui_SendingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dynamic_ui_sending = /** @type {((inputs?: Dynamic_Ui_SendingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dynamic_Ui_SendingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dynamic_ui_sending(inputs)
	if (locale === "bn") return bn_dynamic_ui_sending(inputs)
	if (locale === "de") return de_dynamic_ui_sending(inputs)
	if (locale === "es") return es_dynamic_ui_sending(inputs)
	if (locale === "fr") return fr_dynamic_ui_sending(inputs)
	if (locale === "pt") return pt_dynamic_ui_sending(inputs)
	if (locale === "zh") return zh_dynamic_ui_sending(inputs)
	if (locale === "tr") return tr_dynamic_ui_sending(inputs)
	if (locale === "ru") return ru_dynamic_ui_sending(inputs)
	if (locale === "pl") return pl_dynamic_ui_sending(inputs)
	return en_dynamic_ui_sending(inputs)
});